import React, { useEffect, useState } from 'react';
import { TartaWordmark } from './TartaWordmark';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navLeft = [{
    label: t.header.navCheesecake,
    href: '#product'
  }, {
    label: t.header.navOccasions,
    href: '#perfect-for'
  }];
  const navRight = [{
    label: t.header.navEnquiries,
    href: '#faq'
  }, {
    label: t.header.navReserve,
    href: '#waitlist'
  }];
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const LangToggle = ({
    className = ''
  }: {
    className?: string;
  }) => <div className={`flex items-center text-[10px] tracking-[0.3em] uppercase ${className}`} data-id="element-71">
      <button onClick={() => setLang('en')} className={`transition-colors duration-300 ${lang === 'en' ? 'text-caramel' : 'text-cream/40 hover:text-cream/70'}`} aria-label="Switch to English" aria-pressed={lang === 'en'} data-id="element-72">
        EN
      </button>
      <span className="mx-2 text-cream/25" data-id="element-73">/</span>
      <button onClick={() => setLang('es')} className={`transition-colors duration-300 ${lang === 'es' ? 'text-caramel' : 'text-cream/40 hover:text-cream/70'}`} aria-label="Cambiar a Español" aria-pressed={lang === 'es'} data-id="element-74">
        ES
      </button>
    </div>;
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${scrolled ? 'bg-chocolate/85 backdrop-blur-xl border-b border-cream/5' : 'bg-transparent'}`} data-id="element-75">
      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-16 h-24 lg:h-28 flex items-center justify-center" data-id="element-76">
        {/* Desktop left nav */}
        <nav className="hidden md:flex items-center gap-10 absolute left-6 lg:left-16 top-1/2 -translate-y-1/2" data-id="element-77">
          {navLeft.map(link => <a key={link.href} href={link.href} className="text-[10px] tracking-[0.3em] uppercase text-cream/60 hover:text-cream transition-colors duration-500 relative group" data-id="element-78">
              {link.label}
              <span className="absolute -bottom-1.5 left-0 w-0 h-px bg-caramel transition-all duration-500 group-hover:w-full" data-id="element-79" />
            </a>)}
        </nav>

        {/* Mobile hamburger */}
        <button onClick={() => setOpen(!open)} className="md:hidden absolute left-6 top-1/2 -translate-y-1/2 text-cream" aria-label="Toggle menu" data-id="element-80">
          <div className="w-6 flex flex-col gap-1.5" data-id="element-81">
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'rotate-45 translate-y-1.5' : ''}`} data-id="element-82" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'opacity-0' : ''}`} data-id="element-83" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? '-rotate-45 -translate-y-1.5' : ''}`} data-id="element-84" />
          </div>
        </button>

        {/* Centered wordmark */}
        <a href="#top" className="flex flex-col items-center text-cream" data-id="element-85">
          <TartaWordmark height={22} data-id="element-86" />
          <span className="mt-2.5 text-[9px] tracking-[0.4em] uppercase text-cream/50" data-id="element-87">
            {t.header.tagline}
          </span>
        </a>

        {/* Desktop right nav + language toggle */}
        <div className="hidden md:flex items-center gap-8 lg:gap-10 absolute right-6 lg:right-16 top-1/2 -translate-y-1/2" data-id="element-88">
          <nav className="flex items-center gap-8 lg:gap-10" data-id="element-89">
            {navRight.map((link, i) => {
            const isReserve = i === navRight.length - 1;
            return <a key={link.href} href={link.href} className={`text-[10px] tracking-[0.3em] uppercase transition-colors duration-500 relative group ${isReserve ? 'text-caramel hover:text-cream' : 'text-cream/60 hover:text-cream'}`} data-id="element-90">
                  {link.label}
                  <span className={`absolute -bottom-1.5 left-0 h-px transition-all duration-500 ${isReserve ? 'w-full bg-caramel/50 group-hover:bg-caramel' : 'w-0 bg-caramel group-hover:w-full'}`} data-id="element-91" />
                </a>;
          })}
          </nav>
          <span className="w-px h-3 bg-cream/20" aria-hidden data-id="element-92" />
          <LangToggle data-id="element-93" />
        </div>

        {/* Mobile right — language toggle (Reserve moves to hamburger menu) */}
        <div className="md:hidden absolute right-6 top-1/2 -translate-y-1/2" data-id="element-94">
          <LangToggle data-id="element-95" />
        </div>
      </div>

      {open && <div className="md:hidden bg-chocolate/95 backdrop-blur-xl border-t border-cream/5 px-8 py-8 space-y-5" data-id="element-96">
          {[...navLeft, ...navRight].map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block text-[10px] tracking-[0.3em] uppercase text-cream/80" data-id="element-97">
              {link.label}
            </a>)}
        </div>}
    </header>;
}